<ng-container *ngIf="!isLoading">

<div style="text-align: end;">
    <div style="margin-left: 70%; margin-bottom: 2%;">

      <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary" (click)="printPage()">
        Print
      </button>

      <button class="noPrint" style="margin-top: 2% 2% 0 2%; margin-left: 2%;"
        (click)="exportExcel('Talukawise Office_Reprensentative_Subscription_Business_Report')" mat-raised-button
        color="primary">
        Export
      </button>

      <button mat-dialog-close class="btn noPrint">
        Close
      </button>
    </div>
  </div>

  <div>
    <div class="container" id="print-section1">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th [attr.colspan]="totalth - 0" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 13px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
            <th [attr.colspan]="totalth - 3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black; ">
              वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ - तालूकानुसार कार्यालयीन प्रतिनिधी 
               <span *ngIf="appliedFilters">
                    <small>
                        <!-- <span *ngIf="appliedFilters.country"> |<strong>देश:</strong>  {{ appliedFilters.country }}</span>
                        <span *ngIf="appliedFilters.state"> | <strong>राज्य:</strong> {{ appliedFilters.state }}</span>
                        <span *ngIf="appliedFilters.district"> |<strong>जिल्हा:</strong> {{ appliedFilters.district }}</span>
                        <span *ngIf="appliedFilters.taluka"> | <strong>तालुका:</strong> {{ appliedFilters.taluka }}</span>
                        <span *ngIf="appliedFilters.subscriptionType"> |<strong>वर्गणी प्रकार:</strong>  {{ appliedFilters.subscriptionType }}</span>
                        <span *ngIf="appliedFilters.rep"> | <strong>प्रतिनिधी: </strong> {{ appliedFilters.rep }}</span>
                        <span *ngIf="appliedFilters.officerep"> |<strong>कार्यालय प्रतिनिधी:</strong> {{ appliedFilters.officerep }}</span>
                        <span *ngIf="appliedFilters.prant"> | <strong>प्रांत:</strong> {{ appliedFilters.prant }}</span>
                        <span *ngIf="appliedFilters.receiptType"> | <strong>पावती प्रकार:</strong> {{ appliedFilters.receiptType }}</span> -->


                        <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>देश:</strong> <strong>{{ appliedFilters.country }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.state && appliedFilters.state.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>राज्य:</strong> <strong>{{ appliedFilters.state }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.district && appliedFilters.district.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>जिल्हा:</strong> <strong>{{ appliedFilters.district }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.taluka && appliedFilters.taluka.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>तालुका:</strong> <strong>{{ appliedFilters.taluka }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.subscriptionType && appliedFilters.subscriptionType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>वर्गणी प्रकार:</strong> <strong>{{ appliedFilters.subscriptionType }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.rep && appliedFilters.rep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रतिनिधी:</strong> <strong>{{ appliedFilters.rep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.officerep && appliedFilters.officerep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>कार्यालय प्रतिनिधी:</strong> <strong>{{ appliedFilters.officerep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.prant && appliedFilters.prant.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रांत:</strong> <strong>{{ appliedFilters.prant }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.receiptType && appliedFilters.receiptType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>पावती प्रकार:</strong> <strong>{{ appliedFilters.receiptType }}</strong>
                        </span>	 

                    </small>
                </span>
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 13px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ startdate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 13px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              पर्यंत - {{ enddate | date:'dd-MM-yyyy' }}
            </th>
          </tr>

         
          <tr>
            <th colspan="1"
              style="font-weight: bold; border-left: 2px solid black; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 14px;">
              देश</th>
            <th colspan="1"
              style="font-weight: bold; border-left: 2px solid black; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 14px;">
              राज्य</th>
            <th colspan="1"
              style="font-weight: bold; border-left: 2px solid black; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 14px;">
              जिल्हा</th>
              <th colspan="1"
                style="font-weight: bold; border-left: 2px solid black; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 14px;">
                तालुका</th>

            <th *ngIf="totalth >= 10" colspan="4"
              style="font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 14px;">
              एकूण</th>
            <ng-container *ngFor="let subtype of subTypesName">
              <th *ngIf="subtype.isVisible" colspan="4"
                style=" border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 14px;">
                {{ subtype.name }}</th>
            </ng-container>
          </tr>





<ng-container *ngFor="let country of finalData; let firstIndex = first">
  <tr *ngIf="firstIndex" style="text-align: right;">
    <th colspan="4" style="border-left: 2px solid black; border-right: 1px solid black; border-bottom: 2px solid black;"></th>
    <th style="word-break: break-word; border-bottom: 2px solid black; border-right: 1px solid black; border-left: 2px solid black; font-size: 13px;">वर्गणीदार संख्या</th>
    <th style="word-break: break-word; border-bottom: 2px solid black; border-right: 1px solid black; font-size: 13px;">रक्कम</th>
    <th style="word-break: break-word; border-bottom: 2px solid black; border-right: 1px solid black; font-size: 13px;">नवीन</th>
    <th style="word-break: break-word; border-bottom: 2px solid black; border-right: 2px solid black; font-size: 13px;">नूतनीकरण</th>

    <ng-container *ngFor="let data of subTypesName">
      <ng-container *ngIf="data.isVisible">
        <th style="word-break: break-word; border-left: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black; font-size: 13px;">नवीन</th>
        <th style="word-break: break-word; border-right: 1px solid black; border-bottom: 2px solid black; font-size: 13px;">नूतनीकरण</th>
        <th style="word-break: break-word; border-right: 1px solid black; border-bottom: 2px solid black; font-size: 13px;">एकूण</th>
        <th style="word-break: break-word; border-right: 2px solid black; border-bottom: 2px solid black; font-size: 13px;">रक्कम</th>
      </ng-container>
    </ng-container>
  </tr>

  <!-- Country-level rows (skip finalData row here) -->
  <ng-container *ngIf="country.key !== 'finalData'">
    <!-- Country header -->
    <tr>
      <th colspan="1" style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; font-size: 13px; border-bottom: 2px solid black; border-right: 2px solid black;">
        {{ country.key }}
      </th>
      <th colspan="3" style="border-right: 2px solid black; border-bottom: 1px solid black;"></th>

      <ng-container *ngFor="let sub of subTypesName">
        <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
        <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
        <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
        <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
      </ng-container>

      <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
      <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
      <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
      <td style="border: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
    </tr>

    <!-- State -->
    <ng-container *ngFor="let stateKV of country.value | keyvalue">
      <tr>
        <th colspan="1" style="border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;"></th>
        <th colspan="1" class="state-col" style="border-left: 1px solid black; border-top: 2px solid black; font-size: 13px; font-weight: bold; border-bottom: 2px solid black; border-right: 2px solid black;">
          {{ stateKV.key }}
        </th>
        <th colspan="2" style="border-right: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></th>

        <ng-container *ngFor="let sub of subTypesName">
          <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
          <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
          <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
          <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
        </ng-container>

        <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
        <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
        <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
        <td style="border: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
      </tr>

      <!-- District -->
      <ng-container *ngFor="let districtKV of stateKV.value | keyvalue">
        <tr>
          <th colspan="1" style="font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black; border-top: 2px solid black;"></th>
          <th colspan="1" style="border-bottom: 2px solid black; border-right: 1px solid black; border-left: 1px solid black; border-top: 2px solid black;"></th>
          <th colspan="1" style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; font-size: 13px; border-bottom: 2px solid black; border-right: 2px solid black;">
            {{ districtKV.key }}
          </th>

          <ng-container *ngFor="let sub of subTypesName">
            <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
            <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
            <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
            <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
          </ng-container>

          <td style="border: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
          <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
          <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
          <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
          <td style="border: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
        </tr>

        <!-- Talukas: iterate entries, then filter out the districtTotal key inside -->
        <ng-container *ngFor="let talukaKV of districtKV.value | keyvalue">
          <ng-container *ngIf="talukaKV.key !== 'districtTotal'">
            <!-- Taluka header -->
            <tr>
              <th colspan="1" style="font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;"></th>
              <th colspan="1" style="font-weight: bold; border-left: 1px solid black; border-bottom: 2px solid black;border-right: 1px solid black; border-top: 2px solid black;"></th>
              <th colspan="1" style="border-bottom: 2px solid black; border-right: 1px solid black; border-top: 2px solid black;"></th>
              <th colspan="1" style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; font-size: 13px; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{ talukaKV.key }}
              </th>

              <ng-container *ngFor="let sub of subTypesName">
                <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
                <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
                <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
                <td *ngIf="sub.isVisible" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
              </ng-container>

              <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
              <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
              <td style="border: 1px solid black; border-bottom: 1px solid black;"></td>
              <td style="border: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
            </tr>

            <!-- Office representatives for this taluka (now showing office totals) -->
            <ng-container *ngIf="talukaKV.value.officeRepresentatives">
              <ng-container *ngFor="let offRepKV of talukaKV.value.officeRepresentatives | keyvalue">
                <tr>
                  <!-- Office name -->
                  <td colspan="4" style="font-weight: bold; font-size: 13px; border: 1px solid black; text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ offRepKV.key }}</td>

                  <!-- Office-level totals (show actual data, not empty placeholders) -->
                  <td style="border: 1px solid black;"></td>
                  <td style="border: 1px solid black;"></td>
                  <td style="border: 1px solid black;"></td>
                  <td style="border: 1px solid black; border-right: 2px solid black;"></td>

                  <!-- Office-level subtype totals -->
                  <ng-container *ngFor="let sub of subTypesName">
                    <td *ngIf="sub.isVisible" style="border: 1px solid black;"></td>
                    <td *ngIf="sub.isVisible" style="border: 1px solid black;"></td>
                    <td *ngIf="sub.isVisible" style="border: 1px solid black;"></td>
                     <td *ngIf="sub.isVisible" style="border: 1px solid black; border-right: 2px solid black;"></td>
                  </ng-container>
                </tr>

                <!-- Representatives rows -->
                <ng-container *ngFor="let repKV of offRepKV.value.representatives | keyvalue">
                  <tr>
                    <td colspan="4" style="border: 1px solid black; font-size: 13px; text-align: left; border-left: 2px solid black; border-right: 2px solid black;">{{ repKV.key }} - {{ repKV.value.taluka }}</td>
                    <td style="text-align: right; border: 1px solid black;">{{ (repKV.value?.new_count || 0) + (repKV.value?.renew_count || 0) }}</td>
                    <td style="text-align: right; border: 1px solid black;">{{ repKV.value?.total_amt }}</td>
                    <td style="text-align: right; border: 1px solid black;">{{ repKV.value?.new_count }}</td>
                    <td style="text-align: right; border: 1px solid black; border-right: 2px solid black;">{{ repKV.value?.renew_count }}</td>

                    <ng-container *ngFor="let sub of subTypesName">
                      <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black;">{{ repKV.value?.[getKey(sub.name) + '_नवीन'] }}</td>
                      <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black;">{{ repKV.value?.[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                      <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black;">
                       {{ (repKV.value?.[getKey(sub.name) + '_नवीन'] || 0) +  (repKV.value?.[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
                      </td>
                      <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; border-right: 2px solid black;">{{ repKV.value?.[getKey(sub.name) + '_एकूण'] }}</td>
                    </ng-container>
                  </tr>
                </ng-container>

                <!-- Office rep total row -->
                <tr class="total-row">
                  <td colspan="4" style="font-weight: bold; border: 1px solid black; font-size: 13px; text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ offRepKV.key }} - एकूण :-</td>
                  <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (offRepKV.value?.new_count || 0) + (offRepKV.value?.renew_count || 0) }}</td>
                  <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ offRepKV.value?.total_amt }}</td>
                  <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ offRepKV.value?.new_count }}</td>
                  <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;  ">{{ offRepKV.value?.renew_count }}</td>

                  <ng-container *ngFor="let sub of subTypesName">
                    <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ offRepKV.value?.[getKey(sub.name) + '_नवीन'] }}</td>
                    <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ offRepKV.value?.[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                    <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;"> 
                      {{ (offRepKV.value?.[getKey(sub.name) + '_नवीन'] || 0) + (offRepKV.value?.[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
                    </td>
                    <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ offRepKV.value?.[getKey(sub.name) + '_एकूण'] }}</td>
                  </ng-container>
                </tr>
              </ng-container>
            </ng-container>

            <!-- Taluka Total -->
            <tr class="total-row">
              <td colspan="4" style="font-weight: bold; text-align: right; border: 1px solid black; font-size: 13px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ talukaKV.key }} - एकूण :-</td>
              <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;"> {{ (talukaKV.value.finalData?.['नवीन'] || 0) + (talukaKV.value.finalData?.['नूतनीकरण'] || 0) }}</td>
              <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ talukaKV.value.finalData?.['एकूण'] }}</td>
              <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ talukaKV.value.finalData?.['नवीन'] }}</td>
              <td style="text-align: right; border: 1px solid black; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ talukaKV.value.finalData?.['नूतनीकरण'] }}</td>

              <ng-container *ngFor="let sub of subTypesName">
                <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ talukaKV.value.finalData?.[getKey(sub.name) + '_नवीन'] }}</td>
                <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ talukaKV.value.finalData?.[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                   {{ (talukaKV.value.finalData?.[getKey(sub.name) + '_नवीन'] || 0) + (talukaKV.value.finalData?.[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
                </td>
                <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ talukaKV.value.finalData?.[getKey(sub.name) + '_एकूण'] }}</td>
              </ng-container>
            </tr>
          </ng-container>
        </ng-container>

        <!-- District Total (render AFTER all talukas for this district) -->
        <tr class="total-row">
          <td colspan="4" style="font-weight: bold; text-align: right; border: 1px solid black; font-size: 13px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ districtKV.key }} - एकूण :-</td>
          <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;"> {{ (districtKV.value.districtTotal?.['नवीन'] || 0) + (districtKV.value.districtTotal?.['नूतनीकरण'] || 0) }}</td>
          <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ districtKV.value.districtTotal?.['एकूण'] }}</td>
          <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ districtKV.value.districtTotal?.['नवीन'] }}</td>
          <td style="text-align: right; border: 1px solid black; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ districtKV.value.districtTotal?.['नूतनीकरण'] }}</td>

          <ng-container *ngFor="let sub of subTypesName">
            <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ districtKV.value.districtTotal?.[getKey(sub.name) + '_नवीन'] }}</td>
            <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ districtKV.value.districtTotal?.[getKey(sub.name) + '_नूतनीकरण'] }}</td>
            <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{ (districtKV.value.districtTotal?.[getKey(sub.name) + '_नवीन'] || 0) + (districtKV.value.districtTotal?.[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
            </td>
            <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ districtKV.value.districtTotal?.[getKey(sub.name) + '_एकूण'] }}</td>
          </ng-container>
        </tr>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- Final overall total item (the element in finalData with key === 'finalData') -->
  <ng-container *ngIf="country.key === 'finalData'">
    <tr class="total-row">
      <td colspan="4" style="font-weight: bold; border: 1px solid black; font-size: 14px; text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">एकूण :-</td>
      <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (country.value['नवीन'] || 0) + (country.value['नूतनीकरण'] || 0) }}</td>
      <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ country.value['एकूण'] }}</td>
      <td style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ country.value['नवीन'] }}</td>
      <td style="text-align: right; border: 1px solid black; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ country.value['नूतनीकरण'] }}</td>

      <ng-container *ngFor="let sub of subTypesName">
        <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ country.value[getKey(sub.name) + '_नवीन'] }}</td>
        <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ country.value[getKey(sub.name) + '_नूतनीकरण'] }}</td>
        <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;"> 
        {{ (country.value[getKey(sub.name) + '_नवीन'] || 0) + (country.value[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
        </td>
        <td *ngIf="sub.isVisible" style="text-align: right; border: 1px solid black; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ country.value[getKey(sub.name) + '_एकूण'] }}</td>
      </ng-container>
    </tr>
  </ng-container>
</ng-container>






        </thead>
        <tbody>
          <table>
            <tbody>

            </tbody>
          </table>



        </tbody>
      </table>
    </div>
  </div>

  

</ng-container>
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>